module.exports = __webpack_public_path__ + "img/logo_invoice.e32060fd.png";